
























/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
import RegistPanelComponent from '@/components/construction/constructionregister/RegistPanelComponent.vue';
import hexabaseState from '@/store/hexabase';
import { optionalFormConstruction } from '@/constants/form/form';
import { FieldChildrenProp } from '@/services/hexabase/types';
import ConstructionModel from '@/models/constructionModel';
import ConstructionSubject from '@/models/data/constructionSubject';
import Customer from '@/models/data/customer';
import Department from '@/models/data/department';
import Staff from '@/models/data/staff';

@Component({
  components: {
    RegistPanelComponent
  },
})

export default class ConstructionRegister extends Vue {
  private projectId = hexabaseState.applicationId;

  private constructionModel = new ConstructionModel;

  private constructionSubject = new ConstructionSubject;
  private customer = new Customer;
  private department = new Department;
  private staff = new Staff;

  private basicFieldsData: Array<FieldChildrenProp> = [];
  private basicFieldCols = '';
  private detailFieldsData: Array<FieldChildrenProp> = [];
  private detailFieldCols = '';

  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  private mainDsId = hexabaseState.datastoreIds['工事'];

  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items : {}  // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  }

  private registFieldType: any = {};

  private apiResponse: {[k: string]: any} = {}; // 処理実行後のAPIレスポンス
  private apiSuccessMessage = '';

  async created() {
    await this.getMasterData();
    await this.getBasicFields();
  }

  /**
   * 各種入力フォームで使用するマスタを取得します
   */
  private async getMasterData() {
    const mData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
    mData['m_construction_subject'] = await this.constructionSubject
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_construction_subject'));
    mData['m_customer'] = await this.customer
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_customer'));
    mData['m_department'] = await this.department
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_department'));
    mData['m_staff'] = await this.staff
      .getData()
      .then((data) => this.constructionModel.modifyMasterData(data, 'id', 'm_staff'));
    this.masterData = mData;
  }

  /**
   * 基本情報入力フォームを生成するための設定情報を取得・整形します
   */
  private async getBasicFields() {
    try {
      const newAction = await this.constructionModel
        .getNewActionList(this.mainDsId)
        .then((data) => {
          return data;
        });
      const inputFields = await this.constructionModel
        .getFieldsByActionId(this.mainDsId, newAction.actions[0].action_id)
        .then((data) => {
          return data;
        });
      for (const key in inputFields.action_fields) {
        this.registFieldType[inputFields.action_fields[key].display_id] = inputFields.action_fields[key].dataType;
      }
      const data = await this.constructionModel.makeFieldsList(this.projectId, this.mainDsId).then((data) => {
        return this.constructionModel
          .addOptionalFormField(data, JSON.parse(JSON.stringify(optionalFormConstruction)))
          .map((field) => this.constructionModel.inputRestriction(field, inputFields))
          .map((field) => this.constructionModel.addOptionalMasterData(field, this.masterData));
      });
      const maxColRecode = this.constructionModel.getMaxcolRecode(data);
      const colCount = maxColRecode.col! + maxColRecode.sizeX!;
      const colWidth = 100 / colCount;
      this.basicFieldCols = `${colWidth}% `.repeat(colCount);
      this.basicFieldsData = data;
    } catch (error) {
      console.error(error);
    }
  }

  private createBasicData(response: any) {
    const inputName = response.name;
    const inputValue = response.value;
    if (inputName === 'construction_staff_id') {
      // 担当者マスタ情報から選択されたconstruction_staff_idに関する情報を引き出す
      const checkItem = this.masterData['m_staff'].body.find(v => {
        if (v.id) {
          return v.id === inputValue;
        }
        return false;
      });
      // 部門マスタ情報から選択された担当者マスタ情報のdepartment_idと紐づく情報を引き出す
      const setItem = this.masterData['m_department'].body.find(v => {
        if (v.id) {
          return v.id === checkItem?.department_id;
        }
        return false;
      });
      // 工事基本情報からsupplier_idに該当するインデックスを検索する
      const deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(
        this.basicFieldsData,
        'construction_division_id'
      );
      if (deepIndex) {
        this.basicFieldsData[deepIndex]['props']!.value = setItem?.id;
        this.basicFieldsData[deepIndex]['props']!.outPutData[0]!.value = setItem?.id;
        this.basicFieldsData[deepIndex]['props']!.outPutData[1]!.value = setItem?.name;
        this.registData.item['construction_division_id'] = Number(setItem?.id);
      }
    } else if (inputName === 'customer_id') {
      // 取引先マスタ情報から選択されたconstruction_staff_idに関する情報を引き出す
      const checkItem = this.masterData['m_customer'].body.find(v => {
        if (v.id) {
          return v.id === inputValue;
        }
        return false;
      });
      // 工事基本情報からbilling_destination_nameに該当するインデックスを検索する
      let deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(
        this.basicFieldsData,
        'billing_destination_name'
      );
      if (deepIndex) {
        this.basicFieldsData[deepIndex]['props']!.value = checkItem?.name;
        this.registData.item['billing_destination_name'] = checkItem?.name;
      }

      // 工事基本情報からbilling_person_telに該当するインデックスを検索する
      deepIndex = this.constructionModel.getDetailFieldsDataDeepIndex(
        this.basicFieldsData,
        'billing_person_tel'
      );
      if (deepIndex) {
        this.basicFieldsData[deepIndex]['props']!.value = checkItem?.tel_number;
        this.registData.item['billing_person_tel'] = checkItem?.tel_number;
      }
    }
    
    const dataType = this.registFieldType[response.name];
    switch (dataType) {
      case 'number':
        response.value = Number(response.value);
        break;
    }
    // 決算年度から期を設定する
    if (response.name === 'fiscal_year') {
      const index = this.basicFieldsData.findIndex(v => v.display_id === 'period');
      const period = response.value - 1959 > 0 ? response.value - 1959 : null;
      this.basicFieldsData[index]['props']!.value = period;
      this.registData.item.period = period;
    }
    this.registData.item[response.name] = response.value;
  }

  private async buttonAction(type: any) {
    switch (type) {
      case 'register': {
        // 1. 「採番管理」テーブルに対して、検索条件に登録する「期」を指定してレコード取得。
        const searchParams = {
          conditions: [
            {
              id: 'period',
              search_value: [String(this.registData.item.period), String(this.registData.item.period)]
            }
          ],
          sort_field_id: 'construction_no',
          sort_order: 'desc',
          per_page: 0,
          page: 1,
          use_display_id: true
        };
        const searchResult = await this.constructionModel.getItemList(hexabaseState.applicationId, hexabaseState.datastoreIds['採番管理'], searchParams);
        const periodConstructionNumber = searchResult.length > 0 ? Number(searchResult[0].construction_no) + 1 : 1;
        // getAutoNumberAPIで連番を取得しておく
        const autoNumber = await this.constructionModel.getAutoNumber(hexabaseState.applicationId, hexabaseState.datastoreIds['採番管理'], 'id', {});

        // 2. 「採番管理」テーブルにレコード登録。1で取得したAPI返り値に含まれる「工事番号」の値 + 1の数値で「工事番号」にセットする

        // 3.「工事」テーブルにレコード登録。2でセットした「工事番号」と同様の値を「工事番号」にセット。
        this.registData.item.construction_no = periodConstructionNumber;
        // 採番管理テーブルの「id」項目との紐づけとしてgetAutoNumberAPIで取得した連番を「採番管理ID」項目にセット
        this.registData.item.numbering_management_id = autoNumber.result.value;

        // 「採番管理」テーブルへのINSERTと、「工事」テーブルへのINSERTを1トランザクションで実行
        const batchActionPayload = {
          ensure_transaction: true,
          item_actions: {
            [hexabaseState.datastoreIds['採番管理']]: [
              {
                operation: 1, // new
                item: {
                  period: this.registData.item.period,
                  construction_no: periodConstructionNumber
                }
              }
            ],
            [this.mainDsId]: [
              {
                operation: 1, // new
                item: this.registData.item
              }
            ]
          }
        };
        this.apiResponse = await this.constructionModel.executeBatchAction(
          hexabaseState.applicationId,
          batchActionPayload
        );

        const constructionManagementNumber = this.registData.item.period + '-' + periodConstructionNumber + '-' + this.registData.item.construction_subject_id
        this.apiSuccessMessage = '工事管理番号：' + constructionManagementNumber + ' で登録しました。';
        break;
      }
    }
  }

  /**
   * ポップアップの処理完了時確認ボタン押下時処理
   * ポップアップを閉じる前に
   * @returns {void} - 一覧画面へ遷移
   */
  private successOpratipon(): void {
    this.$router.push({ name: 'ConstructionList'});
  }
}
